import React from "react";
import Breadcrumb from "./Breadcrumb";
const breadcrumb = {
  backgroundColor: 'white',
  border: '1px solid rgba(0, 0, 0, 0.125)',
  borderRadius: '0.37rem'
}

 

function BreadcrumbList(props) {
  return (
    <div style= {{textAlign: "left"}}>
        <ul className="documentcentre-breadcrumbs" style={ breadcrumb }>
         {props.crumbs.map((c, index) => {
          return (
       
          
       <Breadcrumb key={index} isSeperator={c.isSeperator} name={c.name.toString()} disabled={c.disabled} title={c.title} href={c.href} />  
       

          );    
         })
        }
             </ul>
    </div>
  );
}

/**/
export default BreadcrumbList;